import Vue from 'vue'
import Router from 'vue-router'
import SDRouter from './SDindex'
import GDRouter from './GDindex'
import HBRouter from './HBindex'
import GDXFXFRouter from './GDWXXFindex'
import wx from 'weixin-js-sdk'
import request from '../libs/request'
Vue.use(Router)

const router = new Router({
  routes: [{
    path: '/index',
    name: 'index',
    meta: {
      title: '首页'
    },
    component: () => import('@/pages/callfee/blank')
  },
  {
    path: '/callfee',
    name: 'callfee',
    meta: {
      title: '首页',
      notShare: true
    },
    component: () => import('@/pages/callfee/Index')
  },
  {
    path: '/register',
    name: 'register',
    meta: {
      title: '活动',
      notShare: true
    },
    component: () => import('@/pages/callfee/Register')
  }, {
    path: '/rechargeresult',
    name: 'rechargeresult',
    meta: {
      title: '充值结果',
      notShare: true
    },
    component: () => import('@/pages/callfee/rechargeResult')
  },
  {
    path: '/qrcode',
    name: 'qrcode',
    meta: {
      title: '关注融至联',
      notShare: true
    },
    component: () => import('@/pages/callfee/Qrcode')
  }

  ]
})
// 山东
router.addRoutes(SDRouter)

// 广东
router.addRoutes(GDRouter)

// 河北
router.addRoutes(HBRouter)

// 广东吸粉活动
router.addRoutes(GDXFXFRouter)

router.afterEach((to, from) => {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title
  }
  if (to.meta && to.meta.notShare) {
    // const _this = this
    const url = location.href.split('#')[0]
    request.post('callfee/share', {
      url
    }).then(res => {
      wx.config({
        debug: false,
        appId: res.appId,
        timestamp: res.timestamp,
        nonceStr: res.nonceStr,
        signature: res.signature,
        jsApiList: ['hideAllNonBaseMenuItem']
      })
      wx.ready(function () {
        wx.hideAllNonBaseMenuItem()
      })
    })
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js